import { Component, OnInit, ViewEncapsulation, AfterViewInit, Input } from '@angular/core';
import { Helpers } from '../../helpers';
import { Router } from '@angular/router';

declare let mLayout: any;
@Component({
  selector: 'app-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlaceholderComponent implements OnInit, AfterViewInit {
  @Input()
  currentRoute: any;

  currentUser: any;
  constructor(private _router: Router) {}
  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
  }
  ngAfterViewInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/placeholder/placeholder.component.ts